import { z } from 'zod'

/** The status of the report created. */
export const StatusReport = z.enum(['DONE', 'IN_PROGRESS', 'FAILED'])
export type StatusReport = z.infer<typeof StatusReport>

/** The view mode choice to display tables. */
export const ViewReport = z.enum(['GROUPED', 'SPLIT'])
export type ViewReport = z.infer<typeof ViewReport>
